import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { SsoStatus } from 'src/app/models/shared/sso-status.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);

  public getStatus(): Observable<SsoStatus> {
    return this.http.get<SsoStatus>('/sso/status').pipe(
      catchError(() => {
        return of({
          logged: false,
        });
      })
    );
  }
}
